/**
 * After a new version of the site is deployed, the old game files are gone. A page that was opened before
 * the deploy still asks for the old file names, so loading a game fails ("Couldn't load"). When that happens
 * we reload once to pick up the new version. A short cooldown in sessionStorage stops a reload loop if the
 * failure is something else (for example, the player is offline).
 */
const KEY = 'sf:stale-reload';
const COOLDOWN_MS = 60_000;

/** Reloads the page to fetch the latest version. Returns false if it already tried very recently. */
export function reloadForNewVersion(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < COOLDOWN_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* storage blocked: still try once */
  }
  location.reload();
  return true;
}

/** Vite fires this when a lazily loaded file (a game) fails to download. */
export function installStaleReload(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadForNewVersion()) event.preventDefault();
  });
}
